import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H2, H7 } from 'UIComponents/elements/headings';
import Small from 'UIComponents/elements/Small';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import UISelect from 'UIComponents/input/UISelect';
import UIButton from 'UIComponents/button/UIButton';
import * as Industries from 'marketplace-ui-common/constants/Industry';

/* @ts-expect-error module is untyped */
import { translateFilterValue } from '../../../utils/i18n';
import { INDUSTRY } from '../../../constants/search/FilterKey';
import PillButton from './FindPartnerWizardPillButton';
import { WIZARD_STEP_HEIGHT } from './FindPartnerWizard'; // TODO: Get full list of industries to show as "Top industries"

const topIndustries = [Industries.TECHNOLOGY_SOFTWARE, Industries.CONSULTING_ADVISORY, Industries.BANKING_FINANCIAL_SERVICES, Industries.CONSTRUCTION_RENOVATION, Industries.REAL_ESTATE];
export default function FindPartnerWizardIndustryStep({
  filters,
  onFilterChange,
  userInsights
}) {
  const [showMore, setShowMore] = useState(false);
  const [guessed, setGuessed] = useState(null);
  const handleFilterChange = useCallback((value, isGuess) => {
    onFilterChange('industry', value);
    setGuessed(isGuess);
  }, [onFilterChange]);
  useEffect(() => {
    if (!filters.industry.length && userInsights.portalInsights.industry && guessed === null) {
      handleFilterChange([userInsights.portalInsights.industry], true);
    }
  }, [handleFilterChange, guessed, filters.industry, userInsights]);
  const options = useMemo(() => Object.keys(Industries).map(option => ({
    text: translateFilterValue(INDUSTRY, option),
    value: option
  })), []);
  const renderedTopIndustries = useMemo(() => {
    const filteredIndustries = topIndustries.filter(industry => !filters.industry.includes(industry));
    const expandable = filteredIndustries.length > 5;

    if (filteredIndustries.length < 5) {
      setShowMore(false);
    }

    if (!showMore) {
      filteredIndustries.splice(5);
    }

    return /*#__PURE__*/_jsxs(Fragment, {
      children: [!!filteredIndustries.length && /*#__PURE__*/_jsx(H7, {
        className: "m-top-4 m-bottom-2 ",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.topIndustries"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: filteredIndustries.map(industry => /*#__PURE__*/_jsx(PillButton, {
          onClick: () => handleFilterChange([...filters.industry, industry], false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `marketplace-ui-common.industry.${industry}.title`
          })
        }, industry))
      }), !showMore && expandable && /*#__PURE__*/_jsx(UIButton, {
        onClick: () => setShowMore(true),
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.seeMore"
        })
      })]
    });
  }, [filters, handleFilterChange, showMore]);
  return /*#__PURE__*/_jsxs(UIWizardStep, {
    style: {
      height: WIZARD_STEP_HEIGHT
    },
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.industry.title"
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      anchorType: "combined",
      options: options,
      onChange: ({
        target: {
          value
        }
      }) => handleFilterChange(value, false),
      multi: true,
      value: filters.industry
    }), guessed && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.guess"
      })
    }), renderedTopIndustries]
  });
}